import { i18n } from '@libs/i18n';
import { Ref } from 'vue';

const { t } = i18n.global;

const EMBEDDED_PUT_OPTION_REQUEST_TYPES = {
  maxPhysical: {
    value: 1,
    title: t('modules.portfolio.embeddedPutOption.requestTypes.maxPhysical'),
  },
  maxCashThenPhysical: {
    value: 2,
    title: t(
      'modules.portfolio.embeddedPutOption.requestTypes.maxCashThenPhysical'
    ),
  },
  selective: {
    value: 3,
    title: t('modules.portfolio.embeddedPutOption.requestTypes.selective'),
  },
};

const PORTFOLIO_QUERY_KEYS = {
  portfolio: ['portfolio'],
  virtualPortfolio: ['virtual-portfolio'],
  embeddedPutOptionReport: ['embedded-put-option-reports'],
  embeddedPutOptionSymbols: ['embedded-put-option'],
  embeddedPutOptionSymbolInfo: (isin: Ref<string>) => [
    'embedded-put-option-symbol-info',
    isin,
  ],
};

const PORTFOLIO_UPDATE_CHANNEL_PREFIX = 'portfo-';

/** Health of the portfolio snapshot returned by OMS in `PortfolioQuery.resultState`. */
const PORTFOLIO_RESULT_STATE = {
  /** Data may be stale; UI should prompt the user to refresh. */
  error: 0,
  /** Data is up to date. */
  success: 1,
} as const;

export {
  EMBEDDED_PUT_OPTION_REQUEST_TYPES,
  PORTFOLIO_QUERY_KEYS,
  PORTFOLIO_UPDATE_CHANNEL_PREFIX,
  PORTFOLIO_RESULT_STATE,
};
